/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@bingads-webui-react/fabric-control';
import { ErrorString } from './shared';

export const CommonTextField = (props) => {
  const {
    column, index, item, keySuffix, data, fieldContent, isDirty, setIsDirty, handleChangeInput, getFieldErrorMsg,
  } = props;
  const [fieldErrorMsg, setFieldErrorMsg] = useState('');
  useEffect(() => { setFieldErrorMsg(getFieldErrorMsg(item[column.fieldName])); }, [data]);

  return (
    <Fragment>
      <TextField
        ariaLabel={`${column.fieldName}Label`}
        key={`${column.fieldName}-${index}-${keySuffix}`}
        className={`target-input ${!data.useParentLevel && (isDirty[`${column.fieldName}-${index}`]) && fieldErrorMsg ? 'input-error-border' : ''}`}
        styles={{ fieldGroup: { width: 92 } }}
        disabled={data.useParentLevel || item.Id}
        defaultValue={fieldContent}
        onChange={(_e, value) => {
          if (!isDirty[`${column.fieldName}-${index}`]) {
            setIsDirty({ ...isDirty, [`${column.fieldName}-${index}`]: true });
          }
          setFieldErrorMsg(getFieldErrorMsg(value));
        }}
        onBlur={(e) => { handleChangeInput({ fieldName: column.fieldName, index }, e.target && e.target.value, 'blur'); }}
      />
      {!data.useParentLevel && (isDirty[`${column.fieldName}-${index}`]) && fieldErrorMsg && <ErrorString error={fieldErrorMsg} />}
    </Fragment>
  );
};

CommonTextField.propTypes = {
  column: PropTypes.shape({}).isRequired,
  item: PropTypes.shape({}).isRequired,
  index: PropTypes.number.isRequired,
  keySuffix: PropTypes.number.isRequired,
  data: PropTypes.shape({}).isRequired,
  fieldContent: PropTypes.string,
  isDirty: PropTypes.shape({}).isRequired,
  setIsDirty: PropTypes.func.isRequired,
  handleChangeInput: PropTypes.func.isRequired,
  getFieldErrorMsg: PropTypes.func.isRequired,
};
CommonTextField.defaultProps = {
  fieldContent: '',
};
